"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
function useRenderCellViews() {
    // the shared table passes the value of the current cell, not the whole record, so each entry reads cellValue
    var renderCellViews = (0, react_2.useCallback)(function (cellValue) {
        var isActive = String(cellValue).toUpperCase() === "ACTIVE";
        return [
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm font-medium text-foreground", children: cellValue || "N/A" }) },
            { key: "surname", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: cellValue || "N/A" }) },
            { key: "cell_number", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: cellValue || "N/A" }) },
            { key: "email", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: cellValue || "N/A" }) },
            {
                key: "role_name",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: cellValue !== null && cellValue !== void 0 ? cellValue : "N/A" })),
            },
            {
                key: "status",
                content: cellValue ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "soft", color: isActive ? "success" : "default", children: isActive ? "Active" : "Inactive" })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "N/A" })),
            },
        ];
    }, []);
    return { renderCellViews: renderCellViews };
}
